/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import { ImageList, ImageListItem } from '@mui/material'

type ImageProps = {
  thumbnail: string
  original_image_url: string
  low_resolution: string
}

type ProductReviewsImageListProps = {
  images: ImageProps[]
  className: string
}

export function ProductReviewsImageList(props: ProductReviewsImageListProps) {
  const { className, images } = props
  return (
    <ImageList variant='quilted' cols={5} rowHeight={50} className={className}>
      {images?.map((item) => (
        <ImageListItem key={item.thumbnail}>
          <img src={`${item.thumbnail}?w=50&h=50&fit=crop&auto=format`} loading='lazy' />
        </ImageListItem>
      ))}
    </ImageList>
  )
}
